<div class="card" [ngClass]="{ 'card-returned_eval': vehicle().status === 'RETURNED_EVAL', 
'size-grid-mode': gridMode(), 
'card-returned_pricing': vehicle().status === 'RETURNED_PRICING' }">

  <div class="card-body">
    <div [ngClass]="{ 'flex-card-grid': gridMode(), 'd-flex flex-column flex-md-row': !gridMode() }">
      @if (!isTransfer() || (vehicle().finalEvalScore)) {
        <div class="card-top-badges">
          <div class="card-status-strip">
            @if (vehicle()?.status !== 'BOUGHT' && vehicle()?.destination) {
            <div class="destination-badge" [matTooltip]="destinationLabel" [ngStyle]="{'background': destination ? 'color-mix(in srgb, #7f2c79 14%, transparent) 100%' : 'color-mix(in srgb, #16b097 14%, transparent) 100%'}">
              <div class="destination-badge-content">
                @if (destination) {
                <i class="fa-regular fa-store showroom"></i>
                } @else {
                  <i class="fa-regular fa-arrow-left-arrow-right trade-in"></i>
                }
              </div>
            </div>
            }
            @if (vehicle().finalEvalScore) {
              <div class="final-eval-score-badge" title="Classificação">
                <i class="fa-solid fa-chart-line final-eval-score-icon" aria-hidden="true"></i>
                <span class="final-eval-score-value">
                  {{ vehicle().finalEvalScore}}
                </span>
              </div>
            }
            @if (!isTransfer()) {
              <div class="tag-container {{ class }}">
                <i class="{{ icon }}">{{ status.materialIcon ? status.materialIcon : ""}}</i>{{ label }}
                <span class="material-icons"></span>
              </div>
            }
          </div>
          @if (showInFastQuoteIcon) {
            <div class="in-fast-quote-top-badge"
                 matTooltip="Em cotação rápida"
                 aria-label="Em cotação rápida">
              <i class="app-icon-fast-lightning"></i>
            </div>
          }
        </div>
      }
      <div class="vehicle-img-container" [ngClass]="{ 'image-margin vehicle-img-card': !gridMode() }">
        @if (vehicle().salesEvent) {
          <div class="sales-event-badge" aria-label="Veículo de feirão">
            <i class="fa-solid fa-tags"></i>
            <span>Feirão</span>
          </div>
        }
        @if (vehicle().imgUrls && (vehicle().imgUrls?.length ?? 0) > 1) {
          <div class="next-img" (click)="nextImg(vehicle())">
            <i class="fa-solid fa-chevron-circle-right"></i>
          </div>
          <div class="prev-img" (click)="prevImg(vehicle())">
            <i class="fa-solid fa-chevron-circle-left"></i>
          </div>
        }
        <a (click)="emitClick()" [routerLink]="toDetails(slug ?? '', vehicle().id ?? '')" [ngClass]="{'center': gridMode()}">
          @if (vehicle().hasImgs) {
            <div class="image-count-container">
              <i class="material-icons"> photo_library</i>
              {{ vehicle().numImages }}
            </div>
          }
          @if (vehicle().hasVideo) {
            <div class="has-video-container">
              <i class="fa-solid fa-video"></i>
            </div>
          }
          @if (vehicle().imgUrls && (vehicle().imgUrls?.length ?? 0) > 0) {
            <div class="card-gallery">
              @for (img of vehicleImages; track img; let i = $index) {
                <img class="rounded card-image" [src]="getSmallImageUrl(img)" [ngClass]="{'show': imgIndex == i}" />
              }
            </div>
          }
          @if (!vehicle().hasImgs) {
            <div class="no-img" [ngClass]="{'image-size-card': gridMode(), 'no-img-size': !gridMode()}">
              <i class="material-icons">photo_library</i>
            </div>
          }
        </a>
      </div>
      <div class="vehicle-info">
        <a (click)="emitClick()" [routerLink]="toDetails(slug ?? '', vehicle().id ?? '')">
          <div class="row">
            <div class="col-md-12">
              <h1 class="name">
                {{ vehicle().makeName }} {{ vehicle().modelName }}
                @if (gridMode()) {<br />}
                {{ vehicle().manufactureYear }}/{{ vehicle().modelYear }}
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="description">
                {{ vehicle().trimName }}
              </div>
            </div>
            <div class="col-md-7 eval-card-progress-wrapper" style="padding-right: 0;">
              <app-evaluation-fill-progress-bar [vehicle]="vehicle()" mode="card"></app-evaluation-fill-progress-bar>
            </div>
            @if (hasPricingResponsible() && !gridMode()) {
              <div class="col-md-5 pricing-responsible-info">
                <div class="responsible-label">Assumido por</div>
                <div class="responsible-user">
                  <div class="avatar-circle-small">
                    <span class="initials">{{ getPricingResponsibleInitials() }}</span>
                  </div>
                  <span class="responsible-name">{{ getPricingResponsibleName() }}</span>
                </div>
              </div>
            }
            @if (hasFirstPricer() && !gridMode()) {
              <div class="col-md-5 pricing-responsible-info">
                <div class="responsible-label">Precificado por</div>
                <div class="responsible-user">
                  <div class="avatar-circle-small">
                    <span class="initials">{{ getFirstPricerInitials() }}</span>
                  </div>
                  <span class="responsible-name">{{ getFirstPricerName() }}</span>
                </div>
              </div>
            }
          </div>
        </a>

        <div class="row" style="height: 100%">
          <div class="col-12 align-self-end">
            <div class="bid-info" [ngClass]="{'flex-column my-2': gridMode()}">
              <div class="d-flex w-100 flex-wrap">

                <!-- FAST QUOTE INFO (list mode) -->
                @if (showInFastQuoteInfo && !gridMode()) {
                  <div class="primary-color w-60">
                    @if ((vehicle().bestBid ?? 0) > 0) {
                      <div class="username">
                        <i class="app-icon-tag"></i>
                        Melhor oferta:&nbsp;<span class="symbol">R$</span> {{ vehicle().bestBid | number }}
                      </div>
                    } @else {
                      <div class="no-result" style="color:#a6aaaf;">
                        <i class="app-icon-tag"></i>
                        Não foram feitas ofertas
                      </div>
                    }
                    @if (vehicle().fipePrice) {
                    <span class="infos text-center">FIPE: R$ {{vehicle().fipePrice | number}}</span>
                    <app-fipe-comparison-badge
                      variant="inline"
                      accentColor="#16B097"
                      cssClass="font-weight-bold"
                      [price]="vehicle().bestBid ?? 0"
                      [fipePrice]="vehicle().fipePrice"
                      [displayMode]="userInfoResolved?.fipeComparisonMode"
                    />
                    }
                  </div>
                  @if (vehicle().status === 'NEGOTIATION') {
                    @if (showPrice) {
                      <div class="d-flex flex-column align-items-end eval-card-proposed-value w-40 flex-shrink-0 text-end" (click)="toDetails(slug ?? '', vehicle().id ?? '')">
                        <span class="text-value-title d-block text-center font-weight-bold text-uppercase">Valor proposto</span>
                        <div class="value">
                          <span class="symbol">R$</span> {{ vehicle().price | number: '1.2-2' }}
                        </div>
                        @if (vehicle().fipePrice) {
                          <div class="infos text-center">FIPE: R$ {{vehicle().fipePrice | number}} </div>
                          <app-fipe-comparison-badge
                            variant="inline"
                            accentColor="#16B097"
                            cssClass="fipe-percentage-info font-weight-bold"
                            [price]="proposedPriceForFipeComparison"
                            [fipePrice]="vehicle().fipePrice"
                            [displayMode]="userInfoResolved?.fipeComparisonMode"
                          />
                        }
                      </div>
                    }
                  } @else if (vehicle().stats) {
                    <div class="stats w-40">
                      <div class="row">
                        <div class="col-md-4 stat-item border-r-dot">
                          <div class="quote-info">
                            <span class="number">{{ vehicle().stats?.uniqueImpressions ?? '0' }}</span>
                            <i class="app-icon-graph"></i><br />
                            impressões
                          </div>
                        </div>
                        <div class="col-md-4 stat-item border-r-dot">
                          @if (vehicle().stats?.uniqueViews) {
                            <div class="quote-info">
                              <span class="number">{{ vehicle().stats?.uniqueViews ?? '0' }}</span>
                              <i class="app-icon-board"></i><br />
                              visualizações
                            </div>
                          }
                        </div>
                        <div class="col-md-4 stat-item">
                          <div class="quote-info">
                            <span class="number">{{ vehicle().stats?.bids ?? '0' }}</span>
                            <i class="app-icon-tag"></i><br />
                            ofertas
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="fast-quote-timer w-100">
                    @if (contador$ | async; as contador) {
                      <div class="d-flex justify-content-end align-items-center">
                        <div class="d-flex flex-grow-1">
                          <div class="progress w-100" style="height: 8px">
                            <div class="progress-bar" [ngClass]="{ 'progress-bar-danger': contador?.danger }"
                              role="progressbar" [style.width.%]="contador?.percentage ?? 0"
                              [attr.aria-valuenow]="contador?.percentage ?? 0" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </div>
                        <div class="time left-padding" [ngClass]="{ 'time-danger': contador?.danger }">
                          <i class="material-icons">timer</i>
                          {{ contador?.days }}d
                          {{ contador?.hours | number: "2.0-0" }}h
                          {{ contador?.minutes | number: "2.0-0" }}m
                          {{ contador?.seconds | number: "2.0-0" }}s
                        </div>
                      </div>
                    }
                    @if ((vehicle().expirationTimeLeft ?? 0) <= 0) {
                      <div class="time left-padding text-center mt-1 mb-1">
                        O tempo de cotação rápida expirou para este veículo
                      </div>
                    }
                  </div>
                }

                <!-- FAST QUOTE INFO (grid mode) -->
                @if (gridMode() && showInFastQuoteInfo) {
                  @if (vehicle().fipePrice) {
                    <div class="infos-card primary-color text-center">FIPE: R$ {{vehicle().fipePrice | number}}</div>
                  }
                  @if ((vehicle().bestBid ?? 0) > 0) {
                    <div class="wrap-box-best-offer w-100">
                      <div class="primary-color w-100">
                        <div class="username center-align w-100">
                          <i class="app-icon-tag"></i>
                          Melhor oferta:&nbsp;<span class="symbol">R$</span> {{ vehicle().bestBid | number }}
                        </div>
                      </div>
                      <div class="fast-quote-timer w-100 container">
                        @if (contador$ | async; as contador) {
                          <div class="d-flex justify-content-end align-items-center">
                            <div class="d-flex flex-grow-1">
                              <div class="progress w-100" style="height: 8px">
                                <div class="progress-bar" [ngClass]="{ 'progress-bar-danger': contador?.danger }"
                                  role="progressbar" [style.width.%]="contador?.percentage ?? 0"
                                  [attr.aria-valuenow]="contador?.percentage ?? 0" aria-valuemin="0" aria-valuemax="100"></div>
                              </div>
                            </div>
                            <div class="time" [ngClass]="{ 'time-danger': contador?.danger }">
                              <i class="material-icons">timer</i>
                              {{ contador?.hours | number: "2.0-0" }}h
                              {{ contador?.minutes | number: "2.0-0" }}m
                              {{ contador?.seconds | number: "2.0-0" }}s
                            </div>
                          </div>
                        }
                        @if ((vehicle().expirationTimeLeft ?? 0) <= 0) {
                          <div class="time text-center mt-1 mb-1">
                            O tempo de cotação rápida expirou para este veículo
                          </div>
                        }
                      </div>
                    </div>
                  } @else {
                    <div class="wrap-box w-100">
                      <div class="primary-color w-100">
                        <div class="center-align" style="color: #2C657F;">
                          <i class="app-icon-tag"></i>&nbsp;
                          Não foram feitas ofertas
                          <br />
                        </div>
                      </div>
                      <div class="fast-quote-timer w-100 container">
                        @if (contador$ | async; as contador) {
                          <div class="d-flex justify-content-end align-items-center">
                            <div class="d-flex flex-grow-1">
                              <div class="progress w-100" style="height: 8px">
                                <div class="progress-bar" [ngClass]="{ 'progress-bar-danger': contador?.danger }"
                                  role="progressbar" [style.width.%]="contador?.percentage ?? 0"
                                  [attr.aria-valuenow]="contador?.percentage ?? 0" aria-valuemin="0" aria-valuemax="100"></div>
                              </div>
                            </div>
                            <div class="time" [ngClass]="{ 'time-danger': contador?.danger }">
                              <i class="material-icons">timer</i>
                              {{ contador?.hours | number: "2.0-0" }}h
                              {{ contador?.minutes | number: "2.0-0" }}m
                              {{ contador?.seconds | number: "2.0-0" }}s
                            </div>
                          </div>
                        }
                        @if ((vehicle().expirationTimeLeft ?? 0) <= 0) {
                          <div class="time text-center mt-1 mb-1">
                            O tempo de cotação rápida expirou para este veículo
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (vehicle().status === 'NEGOTIATION') {
                    @if (showPrice) {
                      <div
                        class="proposed-value w-100 container m-1 p-2 row"
                        (click)="toDetails(slug ?? '', vehicle().id ?? '')">
                        <i class="app-icon-tag"></i>&nbsp;
                        <span class="text-value-title d-block text-center blue-color font-text">Valor proposto</span>
                        <span>: &nbsp;</span>
                        <div class="price">
                          R$ {{ vehicle().price | number: '1.2-2' }}
                        </div>
                      </div>
                    }
                  } @else if (vehicle().stats) {
                    <div class="stats-card w-100 container">
                      <div class="row">
                        <div class="col-md-4 stat-item-card border-r-dot">
                          <div class="quote-info">
                            <span class="number-card">{{ vehicle().stats?.uniqueImpressions ?? '0' }}</span>
                            <i class="app-icon-graph"></i><br />
                            impressões
                          </div>
                        </div>
                        <div class="col-md-4 stat-item-card border-r-dot">
                          @if (vehicle().stats?.uniqueViews) {
                            <div class="quote-info">
                              <span class="number-card">{{ vehicle().stats?.uniqueViews ?? '0' }}</span>
                              <i class="app-icon-board"></i><br />
                              visualizações
                            </div>
                          }
                        </div>
                        <div class="col-md-4 stat-item-card">
                          <div class="quote-info">
                            <span class="number-card">{{ vehicle().stats?.bids ?? '0' }}</span>
                            <i class="app-icon-tag"></i><br />
                            ofertas
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }

                <!-- NORMAL EVAL -->
                @if (!showInFastQuoteInfo) {
                  <div
                    class="eval-card-status-price-row w-100"
                    [ngClass]="gridMode() ? 'd-flex flex-column' : 'd-flex align-items-start'">
                    <a
                      class="username eval-card-status-link"
                      [routerLink]="toDetails(slug ?? '', vehicle().id ?? '')"
                      >
                      @if (initials) {
                        <div class="avatar-circle">
                          <span class="initials">{{ initials }}</span>
                        </div>
                      }
                      @if (descriptionStatus) {
                        <span [ngClass]="{'width': gridMode(), 'eval-card-status-text': true}">
                          {{ descriptionStatus }}
                        </span>
                      }
                    </a>
                    @if (showPrice) {
                    <div
                      [ngClass]="{
                        'proposed-value w-100 container m-1 p-2 row': gridMode(),
                        'eval-card-proposed-value flex-shrink-0 text-end': !gridMode()
                      }"
                      (click)="toDetails(slug ?? '', vehicle().id ?? '')">
                      @if (gridMode()) {
                        <i class="app-icon-tag"></i>&nbsp;
                      }
                      <span
                        class="text-value-title d-block text-center"
                        [ngClass]="{'font-weight-bold text-uppercase': !gridMode(), 'blue-color font-text': gridMode()}">{{ vehicle().status === 'AWAITING_ENTRY' ? 'Valor aceito' : 'Valor proposto' }}</span>
                      @if (gridMode()) {
                        <span>: &nbsp;</span>
                      }
                      <div [ngClass]="{'value': !gridMode(), 'price': gridMode()}">
                        <span [ngClass]="{'symbol': !gridMode()}">R$</span> {{ (vehicle().status === 'AWAITING_ENTRY' ? (vehicle().agreedPrice || vehicle().price) : vehicle().price) | number: '1.2-2' }}
                      </div>
                      @if (vehicle().fipePrice && !gridMode()) {
                        <div class="infos text-center">FIPE: R$ {{vehicle().fipePrice | number}} </div>
                        <app-fipe-comparison-badge
                          variant="inline"
                          accentColor="#16B097"
                          cssClass="fipe-percentage-info font-weight-bold"
                          [price]="proposedPriceForFipeComparison"
                          [fipePrice]="vehicle().fipePrice"
                          [displayMode]="userInfoResolved?.fipeComparisonMode"
                        />
                      }
                    </div>
                    }
                  </div>
                  @if (vehicle().tradeInVehicleId && isTransfer()) {
                    <div class="flex-grow-1 d-flex justify-content-end">
                      <span class="transfer-status success">
                        <i class="material-icons">check_circle</i>
                        Enviado para repasse.
                        <a [href]="getTradeInVehicleUrl()" target="_blank" rel="noopener">
                          Abrir veículo
                        </a>
                      </span>
                    </div>
                  }
                  @if (canTransfer() && isTransfer()) {
                    <div class="flex-grow-1 d-flex justify-content-end">
                      <button class="btn btn-primary btn-pill" (click)="sendToTransfer()">
                        ENVIAR PARA REPASSE
                      </button>
                    </div>
                  }
                }
              </div>
            </div>
          </div>

          <div class="row flex-grow-1 align-content-end container">
            <div class="col-12">
              @if (showProgress) {
                <div class="d-flex align-items-center" style="margin: 12px 0">
                  <div class="d-flex flex-grow-1">
                    <div class="progress w-100" [ngClass]="{'margin': gridMode()}" style="height: 8px">
                      <div class="progress-bar" role="progressbar" [style.width.%]="percentage"
                        [attr.aria-valuenow]="percentage" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              }

              <div class="infos">
                @if (hasPricingResponsible() && gridMode()) {
                  <span>
                    <i class="material-icons">person</i>
                    Assumido por {{ getPricingResponsibleName() }}
                  </span>
                }
                @if (hasFirstPricer() && gridMode()) {
                  <span>
                    <i class="material-icons">person</i>
                    Precificado por {{ getFirstPricerName() }}
                  </span>
                }
                @if (vehicle().km) {
                  <span>
                    <i class="material-icons">maps</i>
                    {{ vehicle().km | number }} km
                  </span>
                }
                <span>
                  <i class="material-icons">label</i>
                  {{ vehicle().numberPlate }}
                </span>
                <span>
                  <i class="material-icons">room</i>
                  {{ vehicle().evalDealerName }}
                  @if (vehicle().city) {
                    - {{ vehicle().city }} / {{ vehicle().uf }}
                  }
                </span>
                <br>
                @if (vehicle().reasonArchive) {
                  <span>
                    <i class="material-icons">details</i>
                    Motivo: {{ getReasonArchiveLabel(vehicle().reasonArchive ?? '') }}
                  </span>
                }
                @if (vehicle().negotiationStatus) {
                  <span>
                    <i class="material-icons">details</i>
                    Status da negociação: {{ getStatusNegotiation(vehicle().negotiationStatus ?? '') }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (showComments) {
    <div class="card-footer">
      @if (initialUserComment) {
        <div class="avatar-circle">
          <span class="initials">{{ initialUserComment }}</span>
        </div>
      }
      {{ comments }} - <span class="time left-padding">{{ dateComment }}</span>
    </div>
  }
</div>
